<template>
    <div class="screen-clock">
        {{year}}年{{month}}月{{day}}日 {{hour}}<span class="divide">{{divide}}</span>{{min}}
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        data() {
            return {
                year: '',
                month: '',
                day: '',
                hour: '',
                min: '',
                divide: ':'
            }
        },
        created() {
            this.initClock()
        },
        methods: {
            initClock() {
                let timer = setInterval(() => {
                    this.year = dayjs().year()
                    this.month = dayjs().month()+1
                    this.day = dayjs().date()
                    this.hour = (dayjs().hour()+'').padStart(2, '0')
                    this.min = (dayjs().minute()+'').padStart(2, '0')
                    this.divide = this.divide === ':'? '': ':'
                }, 500)

                this.$once('hook:beforeDestroy', () => {
                    clearInterval(timer)
                })
            }
        },
    }
</script>

<style scoped lang="scss">
    .screen-clock {
        color: #fff;
        font-weight: 600;
        .divide {
            display: inline-block;
            width: 16px;
        }
    }
</style>
